import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  payments: localStorage.getItem('payments')
    ? JSON.parse(localStorage.getItem('payments'))
    : null,
};

const paymentsSlice = createSlice({
  name: 'payments',
  initialState,
  reducers: {
    setPayments: (state, action) => {
      state.payments = action.payload.allpayments;
      localStorage.setItem('payments', JSON.stringify(action.payload.allpayments));
    },
  },
});

export const {setPayments } = paymentsSlice.actions;

export default paymentsSlice.reducer;
